import React from 'react';
import styles from '../../Home.module.css';

const PaymentMethods = () => (
  <section className={styles.sec} style={{ paddingTop: 0 }} id="features">
    <div className={styles.container}>
      <div className={`${styles.secHead} ${styles.sr}`} data-sr>
        <span className={styles.eyebrow}><span className={styles.dot} />Every way to pay</span>
        <h2>One checkout. Every rail.</h2>
        <p className={styles.secLead}>Let customers pay however they prefer — and capture more sales because of it.</p>
      </div>
      <div className={styles.methods}>
        <div className={`${styles.methodTile} ${styles.sr}`} data-sr>
          <div className={`${styles.mtIc} ${styles.mtIcCoral}`}>
            <svg viewBox="0 0 24 24" width="22" fill="none" stroke="#FF5A36" strokeWidth="2"><rect x="3" y="7" width="18" height="12" rx="2" /><path d="M3 11h18" /></svg>
          </div>
          <h3>Fyntiq Wallet</h3>
          <p>Customers pay in seconds — and you get paid as soon as the same day.</p>
        </div>
        <div className={`${styles.methodTile} ${styles.sr}`} data-sr>
          <div className={`${styles.mtIc} ${styles.mtIcInk}`}>
            <svg viewBox="0 0 24 24" width="22" fill="none" stroke="#F4EFE5" strokeWidth="2"><rect x="3" y="5" width="18" height="14" rx="2" /><path d="M3 10h18" /></svg>
          </div>
          <h3>Cards &amp; digital payments</h3>
          <p>Every major card, plus Apple Pay, Google Pay, and Cash App Pay.</p>
        </div>
        <div className={`${styles.methodTile} ${styles.sr}`} data-sr>
          <div className={`${styles.mtIc} ${styles.mtIcGreen}`}>
            <svg viewBox="0 0 24 24" width="22" fill="none" stroke="#2EB66E" strokeWidth="2"><path d="M3 21h18M5 21V10M19 21V10M3 10l9-6 9 6" /></svg>
          </div>
          <h3>Bank transfer</h3>
          <p>Lower-cost ACH payments for invoices and larger amounts.</p>
        </div>
        <div className={`${styles.methodTile} ${styles.sr}`} data-sr>
          <div className={`${styles.mtIc} ${styles.mtIcYellow}`}>
            <svg viewBox="0 0 24 24" width="22" fill="none" stroke="#161614" strokeWidth="2"><circle cx="12" cy="12" r="9" /><path d="M12 7v5l3 2" /></svg>
          </div>
          <h3>Financing</h3>
          <p>Let customers split purchases with Affirm, Klarna, and Afterpay — plus Fyntiq Financing, coming soon.</p>
        </div>
      </div>
    </div>
  </section>
);

export default PaymentMethods;
